module.exports = __webpack_public_path__ + "static/media/upload.3a02c8f9.svg";